export default "/images/3ff12c9a5d456292ae9556734238ea0b.avif";